import { Directive } from '@angular/core';
import { NgModel } from '@angular/forms';

@Directive({
    selector: 'input[appTimeEntry]'
})
export class TimeEntryDirective {
    lastValue = '';

    constructor(
        private ngModel: NgModel,
    ) {
        ngModel.valueChanges?.subscribe(val => this.formatAsMinSec(val));
    }

    formatAsMinSec(val: any) {
        if (val === this.lastValue)
            return;

        if (val === undefined)
            val = "0000";

        // If the value is a number coming in, convert it to a string
        if (typeof val === 'number')
            val = val.toString();

        // Strip out colons
        val = val.replace(':', '');

        // If the val is longer than 4 characters, pull the last 4 characters (trimming leading zeros or digits)
        if (val.length > 4)
            val = val.substring(val.length - 4);

        // If the val is shorter than 4 characters, pad it with leading zeroes
        if (val.length < 4)
            val = val.padStart(4, '0');

        // Parse out the minute and seconds from the first 2 and last 2 digits respectively
        let minutes = 0;
        let seconds = 0;
        minutes = parseFloat(val.substring(0, val.length - 2));
        seconds = parseFloat(val.substring(val.length - 2));

        // Set the last value since the control.setValue will trigger another ngChange event
        this.lastValue = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        this.ngModel.control.setValue(this.lastValue);
    }
}
